import { Box, Flex, VStack } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { usePayoutQuery } from '@/hooks/queries/use-payout-query';
import { usePayoutCheckoutStore } from '@/stores/payout-checkout-store';
import { CommissionSummaryPanel } from './CommissionSummaryPanel';
import PaymentMethodPanel from './PaymentMethodPanel';
import { PriceSummaryPanel } from './PriceSummaryPanel';

// Main Page Component using the Layout
const PayoutCheckoutPage: React.FC = () => {
  const location = useLocation();
  const { payoutId } = useParams<{ payoutId: string }>();

  const setPayout = usePayoutCheckoutStore((state) => state.setPayout);
  const setPaymentIntentClientSecret = usePayoutCheckoutStore(
    (state) => state.setPaymentIntentClientSecret
  );
  const reset = usePayoutCheckoutStore((state) => state.reset);

  const { data: payout } = usePayoutQuery(payoutId!, ['affiliatePayouts', 'involvedAffiliates']);

  useEffect(() => {
    if (payout) {
      setPayout(payout);
    }
  }, [payout, setPayout]);

  // Effect to store secret if passed via navigation state
  useEffect(() => {
    const secretFromNav = location.state?.paymentIntentClientSecret as string | undefined;
    if (secretFromNav) {
      console.log('Secret found in navigation state, storing...');
      setPaymentIntentClientSecret(secretFromNav);
    }
  }, [location.state, setPaymentIntentClientSecret]);

  // Effect to clean up store on component unmount
  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  return (
    <Flex direction={{ base: 'column', md: 'row' }} gap={8} alignItems="start">
      <VStack alignItems="stretch" flex={1} w="full" gap={8}>
        <CommissionSummaryPanel />
        <PaymentMethodPanel />
      </VStack>
      <Box w={{ base: '100%', md: '360px' }}>
        <PriceSummaryPanel />
      </Box>
    </Flex>
  );
};

export default PayoutCheckoutPage;
